import { render, staticRenderFns } from "./newPageOrderList.vue?vue&type=template&id=090657d4&scoped=true"
import script from "./newPageOrderList.vue?vue&type=script&lang=js"
export * from "./newPageOrderList.vue?vue&type=script&lang=js"
import style0 from "./newPageOrderList.vue?vue&type=style&index=0&id=090657d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090657d4",
  null
  
)

export default component.exports